









































import { Vue, Component, Watch } from 'vue-property-decorator'
import * as _ from 'underscore'
import showDiv, { closeAll } from '@ivy/fts/showDiv'
import startPage from './startPage.vue'
import testPage from './testPage.vue'
import resultPage from './resultPage.vue'
import * as weixin from '@ivy/fts/weixin'
import * as utils from '@ivy/fts/utils'
@Component({
  components: {
    startPage,
    testPage,
    resultPage,
  },
})
export default class ParentTypeTest extends Vue {
  progress = ''
  info
  result
  result_explain
  start_pic_url
  share_pic_url
  status = ''
  shareData = {
    title: `「测一测」你是什么类型的父母？`,
    desc: ``,
    link: '',
    // imgUrl: 'http://service.ivydad.com/course/7c457dbf-d7ba-a218-dbb7-e13489c8b0a8.jpg'
  }
  introduction = ''
  startTest() {
    this.progress = 'test'
  }
  async created() {
    await this.$store.login()
    let { data: activityInfo } = await this.$axios.get(
      '/api/activity/appActivity/typeTestActivity/getTypeTestActivity',
      {
        params: {
          activityId: this.$route.query.activityId,
        },
      }
    )
    this.info = activityInfo.question.map(i => ({
      ...i,
      totalScore: +i.totalScore,
      sumScore: +i.totalScore,
      options: i.options.map(o => ({ ...o, score: 0 })),
    }))
    this.result_explain = activityInfo.result
    this.start_pic_url = activityInfo.bg_pic
    this.introduction = activityInfo.introduction
    this.status = 'loading'
    const img = new Image()
    img.src = this.start_pic_url
    this.share_pic_url = activityInfo.share_pic
    await this.setShare()
    let s = JSON.parse(utils.storeGet('type_test_info') || '{}')
    if (s.progress === 'result' && s.result) {
      this.result = s.result
      this.progress = 'result'
      return
    }
    img.onload = () => {
      this.status = 'finished'
      this.progress = 'start'
    }
  }
  async setShare() {
    let options = {
      ...this.shareData,
      link: window.location.href,
    }
    weixin.weixinShareCallback(options, async f => {
      this.$Toast('分享成功！')
    })
  }
  getResult(result) {
    let res_score_obj = {}
    let highest_score = 0
    result
      .map(r => {
        return r.options.map(op => {
          return [op.relation, +op.score]
        })
      })
      .forEach(f => {
        f.forEach(s => {
          if (res_score_obj[s[0]]) {
            res_score_obj[s[0]] += s[1]
          } else {
            res_score_obj[s[0]] = s[1]
          }
        })
      })
    highest_score = Math.max(..._.map(res_score_obj, v => v))
    this.result = this.result_explain
      .sort((a, b) => {
        return +res_score_obj[b.id] - +res_score_obj[a.id]
      })
      .map((high, index) => ({
        ...high,
        ishide: index === 0 ? 0 : 1,
        total_score: res_score_obj[high.id],
        isHighest: highest_score === res_score_obj[high.id] ? true : false,
      }))
    this.progress = 'result'
  }
  async replay() {
    let { data: activityInfo } = await this.$axios.get(
      '/api/activity/appActivity/typeTestActivity/getTypeTestActivity',
      {
        params: {
          activityId: this.$route.query.activityId,
        },
      }
    )
    this.info = activityInfo.question.map(i => ({
      ...i,
      totalScore: +i.totalScore,
      sumScore: +i.totalScore,
      options: i.options.map(o => ({ ...o, score: 0 })),
    }))
    this.result_explain = activityInfo.result
    this.progress = 'start'
    utils.storeSet(
      'type_test_info',
      JSON.stringify({
        progress: 'start',
      })
    )
    this.result = null
  }
}
